import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

export function TelemetryProvider(props: { children: React.ReactNode }) {
  const prod = import.meta.env.PROD;
  // if (!prod) {
  //   return <>{props.children}</>;
  // }
  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_POSTHOG_HOST
      }}
    >
      {props.children}
    </PostHogProvider>
  );
}

export class Telemetry {
  static Provider = TelemetryProvider;

  static identify(userId: string) {
    posthog.identify(userId);
  }

  static additionalProperties(properties: Record<string, any>) {
    posthog.register(properties);
  }

  static capture(event: string, properties?: Record<string, any>) {
    posthog.capture(event, properties);
  }

  static captureException(error: Error, properties?: Record<string, any>) {
    posthog.captureException(error, properties);
  }
}
